import * as React from "react";
import classNames from "classnames";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { Droppable } from '../react-beautiful-dnd';
import { TagCard } from './TagCard'
import { Trade } from "../../models/Trade";
import { Tag } from "../../models/Tag";

import { lightBlue, lightGreen } from "@material-ui/core/colors";

import { ContextMenuTrigger } from "react-contextmenu";
import { uiActions } from "../../actions/ui.actions";
import { ThunkDispatch } from "redux-thunk";
import { compose } from "redux";
import { connect } from "react-redux";
import {  isDropZoneSelected, isPendingLookaheadDropZone, isPendingPasteDropZone, isCellHighlighted, getClosedRowGroups, shouldColorBottomBorder, getGroupColor, getGroupBounds, isInGroupBounds, Bound, TagRecord, isLockedDown } from "../../selectors/lookahead.selector";
import TrackVisibility from '../react-on-screen';
import { getSize, getZoomAmount } from "./Zoom.util";
import {Animated} from "react-animated-css";
import { GroupTag } from "./GroupTag";
import { ColumnType } from "./Column";
import { RowGroup } from "../../models/Lookahead";
import moment, { Moment } from 'moment'
import RefreshIcon from '@material-ui/icons/Refresh';
import { Receipt } from "@material-ui/icons";
import { lookaheadActions } from "../../actions/lookahead.actions";
const _ = require('lodash')

interface ColumnInnerProps { 
    type: ColumnType;
    isDisabled: boolean;
    isToday: boolean;
    zoomStep: number;
    tags: TagRecord[];
    column: number;
    classes: ClassNameMap;
    trades: Record<string, Trade>; 
    isOffDay: boolean;
    maxIndex: number;
    rowGroups: Record<string, RowGroup>;
    closedRowGroups: number[];
    groupBounds: Record<string, Bound>;
    isAdmin: boolean
    userTrades: Set<string>;
    forceRefreshColumns: string[];
    isLockedDown: boolean
}

const turnToColumnCount = (tagsByColumns: Record<number, Tag[]>) => {
	return Object.entries(tagsByColumns).reduce((newObj, [key, val]) => {
		newObj[key] = val.length

		return newObj
	},{} as Record<string, number>)
}



interface VisibilityComponentProps { 
    column: number;
    index: number;
    isDisabled: boolean;
    zoomStep: any;
    type: ColumnType;
    tagRecord: TagRecord;
    width: number;
    height: number;
    margin: number;
    classes: ClassNameMap;
    trades: Record<string, Trade>;
    fontSize: string;
    shouldColorBottomBorder: boolean;
    groupColor: string;
    isGroupStart: boolean;
    isInGroupBounds: boolean;
    isDropZoneSelected: boolean;
    onColumnClicked: (column: number, row:any, type: ColumnType) => Promise<void>;
    isPendingDropZone: boolean;
    isPendingPasteDropZone: boolean;
    hasTag: boolean;
    tradeColor: string;
    isHighlighted: boolean,
    rowGroups: Record<string, RowGroup>;
    closedRowGroups: number[];
    groupBounds: Record<number, Bound>;
    isAdmin: boolean;
    userTrades: Set<string>;
    isLockedDown: boolean;

}

class _VisibilityComponent extends React.Component<VisibilityComponentProps> {

    
    getTradeColor = ():string => {
        const { tagRecord } = this.props
        if(!tagRecord) {
            return '#000'
        }
        const trade = this.props.trades[tagRecord.tradeId]

        if(!trade) {
            return '#000'
        }
        return trade.color as string
    }

    onDropSelected = async () => {
        const {column, index, type} = this.props
        this.props.onColumnClicked(column, index, type)
    }

    renderDropZoneContent = (provided:any, snapshot:any) => {
        const{ index,  tagRecord } = this.props
        const { width, height } = getSize(getZoomAmount(this.props.zoomStep))

        return (
            <div 
                onClick={this.onDropSelected} 
                style={{
                    borderColor: this.getBackgroundColor(snapshot.isDraggingOver),
                    borderStyle: 'dashed',
                    borderRadius: '10px',
                    borderWidth: '1.5px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems: 'center',
                    width: width - 16, 
                    height: height - 16, 
                    minHeight: height - 16 
                    
                }}
                ref={provided.innerRef}

                {...provided.droppableProps}
            >
                    {this.getTag(index, tagRecord)}
                    {provided.placeholder}
            </div>
        )
    }

    getTradeName = (tradeId:string):string => {

        const trade = this.props.trades[tradeId]
        if(!trade) {
            return ""
        }

        return trade.name as string
    }

    getTag = (index: number,tagRecord?: TagRecord | null) => {

        if(!tagRecord){
            return
        }

        const { isAdmin, userTrades } = this.props
        return (
            <TagCard
                isAdmin={isAdmin}
                userTrades={userTrades}
                type={this.props.type}
                isDisabled={false}
                zoomStep={this.props.zoomStep}
                classes={this.props.classes} 
                uid={tagRecord.uid}
                column={this.props.column}
                index={index}
                tradeName={this.getTradeName(tagRecord.tradeId)}
                tradeColor={this.getTradeColor()}
            />
        )
    }

    shouldComponentUpdate(nextProps: VisibilityComponentProps) {
        if(!!this.props.tagRecord && !!nextProps.tagRecord) {
            return true
        }

        if(this.props.zoomStep !== nextProps.zoomStep) {
            return true
        }
        
        if(!_.isEqual(nextProps.tagRecord, this.props.tagRecord)) {
            return true
        }
        
        if(!_.isEqual(nextProps.trades, this.props.trades)) {
            return true
        }
        
        if(!_.isEqual(nextProps.shouldColorBottomBorder, this.props.shouldColorBottomBorder)) {
            return true
        }
        
        if(nextProps.groupColor !== this.props.groupColor){
            return true
        }

        if(nextProps.tradeColor !== this.props.tradeColor) {
            return true
        }

        if(!_.isEqual(nextProps.tag, this.props.tag)) {
            return true
        }

        if(!_.isEqual(nextProps.hasTag, this.props.hasTag)) {
            return true
        }

        if(this.props.zoomStep !== nextProps.zoomStep) {
            return true
        }

        if(!_.isEqual(this.props.isDisabled, nextProps.isDisabled)) {
            return true
        }

        if(this.props.isDropZoneSelected !== nextProps.isDropZoneSelected) {
            return true
        }

        if(this.props.isPendingDropZone !== nextProps.isPendingDropZone) {
            return true
        }

        if(this.props.isPendingPasteDropZone !== nextProps.isPendingPasteDropZone) {
            return true
        }

        if(this.props.isHighlighted !== nextProps.isHighlighted) {
            return true
        }

        if(this.props.shouldColorBottomBorder != nextProps.shouldColorBottomBorder) {
            return true
        }

        if(this.props.groupColor !== nextProps.groupColor) {
            return true
        }

        if(this.props.isGroupStart !== nextProps.isGroupStart){
            return true
        }

        if(this.props.isLockedDown != nextProps.isLockedDown) {
            return true
        }
        
        return false
    }

    getBackgroundColor = (isDraggingOver: boolean) => {
        const { isDisabled } = this.props
        if(!!isDisabled) {
            return 'transparent'
        }

        if(!!this.props.isDropZoneSelected) {
            return '#4286DD'
        }

        if(!!this.props.isPendingDropZone || !!this.props.isPendingPasteDropZone) {
            return lightGreen[300]
        }


        
        return isDraggingOver ? lightBlue[100] : 'transparent'
    }

    renderCellContent = () => {
        const { isLockedDown, isInGroupBounds, groupBounds, index, column, type, tag, tagRecord, isDisabled, groupColor, height, margin, classes, closedRowGroups, shouldColorBottomBorder, isHighlighted  } = this.props

        const closedRowGroupsSet = new Set<number>(closedRowGroups)


        if(!closedRowGroupsSet.has(index)) {

            const attributes = {
                'column': column,
                'row': index,
            }

            return (
                <ContextMenuTrigger
                        holdToDisplay={-1}
                        disable={!!tag || !!tagRecord || isLockedDown}
                        attributes={attributes} 
                        id="column_context_menu"
                    >
                    <Droppable
                            shouldAnimatePlaceholder={false}
                            isDropDisabled={isDisabled}
                            direction="vertical"
                            droppableId={`${column}/${index}`}
                    >
                        {(provided, snapshot) => this.renderDropZoneContent(provided, snapshot)}
                    </Droppable>
                </ContextMenuTrigger>
            )
        } else {
            if(closedRowGroupsSet.has(index) && isInGroupBounds) {
                return (
                    <GroupTag 
                            zoomStep={this.props.zoomStep}
                            index={index}
                            column={column}
                            groupBounds={groupBounds}
                    />
                )
            }
        }

    }

    render() {
        const { groupColor, height, margin, classes, closedRowGroups, shouldColorBottomBorder, isHighlighted  } = this.props
        const highlightBackGround = isHighlighted ? "rgba(66, 134, 221, 0.2)" : ""

        return (
            <div
                    className={classes.ChartRow}
     
                    style={{
                        backgroundColor: highlightBackGround,
                        display:'flex',
                        justifyContent:'center',
                        alignItems: 'center',
                        width: '100%', 
                        height: height, 
                        minHeight: height,
                        marginTop: margin,
                        marginBottom: margin,
                        borderBottomColor: shouldColorBottomBorder ? groupColor : '#EDEDED',
    
                    }}
            >
                {this.renderCellContent()}
            </div>
        )
    }
}

const mapVisibleCompStateToProps = (state:any, ownProps?: any) => ({
    shouldColorBottomBorder: shouldColorBottomBorder(state, ownProps),
    groupColor: getGroupColor(state, ownProps),
    isHighlighted: isCellHighlighted(state, ownProps),
    isPendingPasteDropZone: isPendingPasteDropZone(state, ownProps),
    isPendingDropZone: isPendingLookaheadDropZone(state, ownProps),
    isDropZoneSelected: isDropZoneSelected(state, ownProps),
    isInGroupBounds: isInGroupBounds(state, ownProps),
    isLockedDown: isLockedDown(state)

});

const mapVisibleCompDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        onColumnClicked: (column:number, row:any, type: ColumnType) => dispatch(uiActions.columnSelectedAsync(column, row, type))
    }
};

const VisibilityComponent = compose(
    connect(mapVisibleCompStateToProps, mapVisibleCompDispatchToProps),
)(_VisibilityComponent)

interface ForceRefreshComponentProps { 
    maxIndex: number;
    classes: ClassNameMap;
    zoomStep: number;
}

class _ForceRefreshComponent extends React.Component<ForceRefreshComponentProps>  {
    
    onForceShowClick = () => {
        const { column, onColumnClicked } = this.props
        onColumnClicked(column)
    }

    render() {
        const { width, height, margin, fontSize } = getSize(getZoomAmount(this.props.zoomStep))
        const { maxIndex } = this.props
        const totalHeight = height * (maxIndex + 5 + 1)
        return(
            <div onClick={this.onForceShowClick} className={classNames(this.props.classes.InnerColumn, this.props.classes.ForceRefreshButton)} style={{height: totalHeight}}>
                <div style={{height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <RefreshIcon  />
                </div>
            </div>
        )
    }
}

const mapForceRefreshCompStateToProps = (state:any, ownProps?: any) => ({
    

});

const mapForceRefreshCompDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        onColumnClicked: (column:string) => dispatch(lookaheadActions.lookaheadForceRefreshAsync(column))
    }
}

const ForceRefreshComponent = compose(
    connect(mapForceRefreshCompStateToProps, mapForceRefreshCompDispatchToProps),
)(_ForceRefreshComponent)

export class InnerList extends React.Component<ColumnInnerProps> {
    shouldComponentUpdate(nextProps: ColumnInnerProps) { 

        if(!_.isEqual(nextProps.tags, this.props.tags)) {
            return true
        }

        if(!_.isEqual(nextProps.zoomStep, this.props.zoomStep)) {
            return true
        }

        if(!_.isEqual(nextProps.trades, this.props.trades)) {
            return true
        }

        if(!_.isEqual(nextProps.maxIndex, this.props.maxIndex)) {
            return true
        }

        if(!_.isEqual(nextProps.closedRowGroups, this.props.closedRowGroups)) {
            return true
        }

        if(!_.isEqual(nextProps.forceRefreshColumns, this.props.forceRefreshColumns)) {
            return true
        }


        return false
    }


    getDropZones = () => {

        const { maxIndex, rowGroups, closedRowGroups, groupBounds, isAdmin, userTrades, tags } = this.props
        const tagsByIndex = _.groupBy(tags, 'indexId')
        let undefinedTags = !!tagsByIndex['undefined'] ? [...tagsByIndex['undefined']] : []

        const { width, height, margin, fontSize } = getSize(getZoomAmount(this.props.zoomStep))
        
        const closedRowGroupsSet = new Set<number>(closedRowGroups)

        
        return new Array(maxIndex+10).fill(2).map((zone, index) => {
            let found = false

            Object.entries(rowGroups).forEach(([, rowGroup]) => {


                const start = parseInt(rowGroup.start)
                const end = rowGroup.end
                if(closedRowGroupsSet.has(start) && index > start && index <= end) {
                    found = true
                }
            })

            if(found) {
                return (
                    <React.Fragment />
                )
            }
            
            const dropZoneIndex = Object.freeze(index)

            const tags = !!tagsByIndex[dropZoneIndex] ? tagsByIndex[dropZoneIndex] : []
            let tagRecord: TagRecord | null | undefined = null

            if(tags.length > 0) {
                const [tagz] = tags
                tagRecord = tagz
            }

            if(tags.length > 1) {
                const [, ...rest] = tags
                undefinedTags = [...undefinedTags, ...rest]
            }



            if(!tagRecord && undefinedTags.length > 0) {
                tagRecord = undefinedTags.pop()
            }
            
            return (

                    <VisibilityComponent
                        isAdmin={isAdmin}
                        userTrades={userTrades}
                        key={`${this.props.column}/${index}`} 
                        classes={this.props.classes} 
                        column={this.props.column}
                        index={index}
                        isDisabled={false}
                        zoomStep={this.props.zoomStep}
                        type={this.props.type}
                        tagRecord={tagRecord}
                        width={width}
                        height={height}
                        margin={margin}
                        fontSize={fontSize}
                        trades={this.props.trades}
                        rowGroups={rowGroups}
                        closedRowGroups={closedRowGroups}
                        groupBounds={groupBounds}
                    />       
            )
        })
    }

    render() {
            const offDayClass = !!this.props.isOffDay ? this.props.classes.OffDayBackground : ""
            const { width, height, margin, fontSize } = getSize(getZoomAmount(this.props.zoomStep))
            const { maxIndex, column, forceRefreshColumns } = this.props
            const totalHeight = height * (maxIndex + 5 + 1)
            const columnString = moment(column).format('l')

            ///const forceRefreshColumnsSet = new Set<string>(alldate)
            return (
                <div className={classNames(this.props.classes.InnerColumn)}>
                    {this.getDropZones()}
                </div>
                                          
            )
    }
}




interface InnerListOwnprops {
    classes: ClassNameMap;
    column: number;
    index: number;
    isDisabled: boolean;
    tags: Tag[];
    trades: Record<string, Trade>;
    type: ColumnType;
    zoomStep: number;
    forceRefreshColumns: string[]
}





// WEBPACK FOOTER //
// ./src/components/PhasePlan/InnerList.tsx